import Spinner from "components/Spinner";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const Button = ({ className = "", children, loading, next, prev, icon, primary, danger, ...rest }) => {
  return (
    <button
      className={`font-semibold opacity-90 hover:opacity-100 whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-50 flex items-center space-x-2
          ${
            primary
              ? "bg-sky-600 hover:bg-sky-700 active:bg-sky-800 text-gray-100 px-6 py-2 text-sm rounded-full"
              : danger
              ? "text-red-600 hover:text-red-700 active:text-red-800 dark:text-red-700 dark:hover:text-red-800 dark:active:text-red-900"
              : "text-sky-600 hover:text-sky-700 active:text-sky-800"
          }
          ${className}
        `}
      {...rest}
      disabled={loading || rest.disabled}
    >
      {loading ? <Spinner size={16} text={null} /> : prev ? <IoChevronBack /> : icon ? icon : null}
      {children ? <div>{children}</div> : null}
      {next ? <IoChevronForward /> : null}
    </button>
  );
};

export default Button;
